import { render, staticRenderFns } from "./DigitalSend.vue?vue&type=template&id=08a921ce&scoped=true&"
import script from "./DigitalSend.vue?vue&type=script&lang=js&"
export * from "./DigitalSend.vue?vue&type=script&lang=js&"
import style0 from "./DigitalSend.vue?vue&type=style&index=0&id=08a921ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a921ce",
  null
  
)

export default component.exports